import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../../components/custom/BackButton';
import { ChangeEvent, IFile } from '../../../../globals/interfaces';
import ActionIcon from '../../../../components/custom/ActionIcon';
import { Form } from 'reactstrap';
import { FormGroup } from 'reactstrap';
import { Input } from 'reactstrap';
import FileBase64 from 'react-file-base64';
import { Label } from 'reactstrap';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    submitDamageReport: (awb_uld: string, comments: string, files: Array<IFile>) => Promise<void>;

}

export default function ModalAddDamageReport({
    modal,
    setModal,
    submitDamageReport
}: Props) {

    //Properties:
    const [comments, setComments] = useState('');
    const [awb_uld, set_awb_uld] = useState('');
    const [files, setFiles] = useState<Array<IFile>>([]);
    const [fileInputKey, setFileInputKey] = useState(0);

    //Procedures:
    const getFiles = (files: Array<IFile>) => setFiles(files);

    const enableSubmitDamageReport = () => {
        return awb_uld.length > 0 && files.length > 0;
    }

    const handleSubmitDamageReport = async () => {
        await submitDamageReport(awb_uld, comments, files);
        reset();
    }

    const reset = () => {
        set_awb_uld('');
        setComments('');
        setFiles([]);
        setFileInputKey(fileInputKey + 1);
    }

    const toggle = () => setModal(!modal);

    useEffect(() => {
        reset();
    }, [modal]);

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Add Damage Report</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label>AWB/ULD</Label>
                        <Input type="text" value={awb_uld} onChange={(e: ChangeEvent) => set_awb_uld(e.target.value)} />
                    </FormGroup>
                    <FormGroup>
                        <Label>Notes</Label>
                        <Input type='textarea' className='mb-3' value={comments} onChange={(e: ChangeEvent) => setComments(e.target.value)} />
                    </FormGroup>
                </Form>
                <FileBase64
                    multiple={true}
                    onDone={getFiles}
                    key={fileInputKey}
                />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon 
                            type={'save'} 
                            onClick={() => submitDamageReport(awb_uld, comments, files)}    
                            disabled={!enableSubmitDamageReport()}
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;